module.exports = __webpack_public_path__ + "img/pieces.b640c77d.svg";